import { get, set, times } from 'lodash';

import { FIELD_PATHS, FIELD_VALUES } from '@funnels/constants';
import { CustomerData, LeadFunnelOneData } from '@funnels/types';
import { initialFormValues } from '@funnels/utils';

export const mapLeadDataToForm = (leadFunnelOneData: LeadFunnelOneData, customer: CustomerData) => {
  const {
    employmentType,
    // contractsExchanged,
    deposit,
    hasSelfEmploymentProof,
    paymentType,
    purpose,
    purchaseSituation,
    refinancingReasons,
    // preApproved,
    propertyUse,
    loanValue,
    securityValue,
    consolidateAmount,
    cashoutAmount,
    urgency,
    firstName,
    estimatedSettlementDate,
    annualInterestRate,
    financialInstitution,
    numberOfBorrowers,
    numberOfProperties,
    buildPriceAmount,
  } = leadFunnelOneData;

  const isRefinance = purpose === FIELD_VALUES.REFINANCE;
  const formValue = isRefinance
    ? initialFormValues.INITIAL_FUNNEL_REFINANCING_FORM_VALUE(customer)
    : initialFormValues.INITIAL_FUNNEL_NEW_PURCHASE_FORM_VALUE(customer);

  // APPLICATION
  set(formValue, FIELD_PATHS.APPLICATION_PRIMARY_PURPOSE(0), purpose);
  set(formValue, FIELD_PATHS.APPLICATION_PURCHASE_SITUATION(0), purchaseSituation);
  set(formValue, FIELD_PATHS.APPLICATION_CONTRIBUTION_AMOUNT(0, 0), deposit);
  set(formValue, FIELD_PATHS.APPLICATION_PAYMENT_TYPE(0), paymentType);

  if (isRefinance) {
    set(formValue, FIELD_PATHS.APPLICATION_REFINANCING_REASONS(0), refinancingReasons);
    set(formValue, FIELD_PATHS.APPLICATION_CONSOLIDATE_AMOUNT(0), consolidateAmount);
    set(formValue, FIELD_PATHS.APPLICATION_CASHOUT_AMOUNT(0), cashoutAmount);
    set(formValue, FIELD_PATHS.APPLICATION_URGENCY(0), urgency);
  }

  // APPLICANT
  set(formValue, FIELD_PATHS.APPLICANT_FIRST_NAME(0), firstName);
  if (numberOfBorrowers > 1) {
    const restOfApplicants = times(numberOfBorrowers - 1, () => initialFormValues.INITIAL_APPLICANT());
    set(formValue, FIELD_PATHS.APPLICANTS(), [get(formValue, FIELD_PATHS.APPLICANT(0)), ...restOfApplicants]);
  }

  // ASSET
  set(formValue, FIELD_PATHS.ASSET_PRIMARY_PURPOSE(0), propertyUse);
  set(formValue, FIELD_PATHS.ASSET_ESTIMATED_VALUE(0), securityValue);
  set(formValue, FIELD_PATHS.ASSET_ESTIMATED_SETTLEMENT_DATE(0), estimatedSettlementDate);
  set(formValue, FIELD_PATHS.ASSET_BUILD_PRICE_AMOUNT(0), buildPriceAmount);
  if (numberOfProperties > 1) {
    const restOfAssets = times(numberOfBorrowers - 1, () => initialFormValues.INITIAL_PROPERTY_ASSET());
    set(formValue, FIELD_PATHS.ASSETS(), [get(formValue, FIELD_PATHS.ASSET(0)), ...restOfAssets]);
  }

  // LIABILITY
  if (isRefinance) {
    set(formValue, FIELD_PATHS.LIABILITY_OUTSTANDING_BALANCE(0), loanValue);
    set(formValue, FIELD_PATHS.LIABILITY_INTEREST_RATE(0), annualInterestRate);
    set(formValue, FIELD_PATHS.LIABILITY_FINANCIAL_INSTITUTION(0), financialInstitution);
  }

  // Employment
  set(formValue, FIELD_PATHS.EMPLOYMENT_EMPLOYMENT_TYPE(0), employmentType);
  set(formValue, FIELD_PATHS.APPLICANT_HAS_SELF_EMPLOYMENT_PROOF(0), hasSelfEmploymentProof);

  return formValue;
};
